module.exports = __webpack_public_path__ + "static/media/hibiki-otsuki-win.8ebab2e7.jpg";